"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.START_A_NEW_ORDER_TEXT = exports.ORDER_FROM_TEXT = exports.GO_TO_LOCATIONS_TEXT = exports.GO_BACK_TO_MENU_TEXT = void 0; // Header Component

var ORDER_FROM_TEXT = '{orderType} from   ';
exports.ORDER_FROM_TEXT = ORDER_FROM_TEXT;
var GO_TO_LOCATIONS_TEXT = 'go to locations';
exports.GO_TO_LOCATIONS_TEXT = GO_TO_LOCATIONS_TEXT;
var GO_BACK_TO_MENU_TEXT = 'Go back to Menu';
exports.GO_BACK_TO_MENU_TEXT = GO_BACK_TO_MENU_TEXT;
var START_A_NEW_ORDER_TEXT = 'Start A New Order';
exports.START_A_NEW_ORDER_TEXT = START_A_NEW_ORDER_TEXT;
var _default = {
  ORDER_FROM_TEXT: ORDER_FROM_TEXT,
  GO_TO_LOCATIONS_TEXT: GO_TO_LOCATIONS_TEXT,
  GO_BACK_TO_MENU_TEXT: GO_BACK_TO_MENU_TEXT,
  START_A_NEW_ORDER_TEXT: START_A_NEW_ORDER_TEXT
};
exports["default"] = _default;